export const environment = {
  production: false,
  authServiceUrl: 'https://sparkonto-test.spara.sparbankensyd.se/service',
  requestApi: 'https://sparkonto-test.spara.sparbankensyd.se/api',
  rtUrl: 'https://sparkonto-test.spara.sparbankensyd.se/interests',
  domain: 'sparkonto-stage.spara.sparbankensyd.se', // We use real BankId on test
  testMode: false
}
